<template>
  <div>
    <!-- 弹出框打印签到表 -->
    <section class="dayincss" ref="print">
      <h2>项目签到表</h2>
      <div class="twohang">
        <span>项目联系人:</span>
        <span>活动时间:</span>
        <div style="width: 50px"></div>
        <span>年</span>
        <div style="width: 50px"></div>
        <span>月</span>
        <div style="width: 50px"></div>
        <span>日</span>
      </div>
      <el-table :data="tableData" :header-cell-style="{ background: '#f8fafa' }" border align="center" 
      current-row-key highlight-current-row > 
        <el-table-column type="index" align="center" label="序号" width="60" ></el-table-column>
        <el-table-column align="center" prop="name" label="姓名" width="90"  :show-overflow-tooltip="true"></el-table-column>
        <el-table-column align="center" prop="phone" label="手机号" width="130px" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column align="center" prop="" label="签到时间"  width="140px" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column align="center" prop="" label="签退时间"  width="140px" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column align="center" prop="cyqk" label="参与情况" width="270px" >
          <el-checkbox label="参加" disabled></el-checkbox>
          <el-checkbox label="未到" disabled></el-checkbox>
          <el-checkbox label="中途离场" disabled></el-checkbox>
        </el-table-column>
        <el-table-column align="center" prop="fwbx" label="服务表现" width="230px" >
          <el-checkbox label="满意" disabled></el-checkbox>
          <el-checkbox label="良好" disabled></el-checkbox>
          <el-checkbox label="差" disabled></el-checkbox>
        </el-table-column>
      </el-table>
      <!-- 分页功能 --> 
      <el-pagination
        :page-size="pageConfig.pageSize" 
        layout="total, prev, pager, next, jumper" 
        @current-change="handleCurrentChange"
        :total="pageConfig.total"></el-pagination>
    </section> 
    <div class="boontbtn">
      <el-button type="primary" size="small" style="margin: 0 30px" @click="dy"
        >打印</el-button
      >
      <el-button type="info" size="small" @click="clearForm()"
        >取消</el-button
      >
    </div>
  </div>
</template>

<script>
import { post } from "@/api/requrestHttp.js";
export default {
  props: ["rowid"],
  data() {
    return {
      id:this.rowid,
      pageConfig: {
        pageNo: 1,
        pageSize: 5,
        total: 0,
      }, 
      //弹出框打印签到表
      print: false,
      tableData: [
        { name: "", cyqk: "", fwbx: "" },
        { name: "", cyqk: "", fwbx: "" },
        { name: "", cyqk: "", fwbx: "" },
        { name: "", cyqk: "", fwbx: "" },
        { name: "", cyqk: "", fwbx: "" },
        { name: "", cyqk: "", fwbx: "" },
        { name: "", cyqk: "", fwbx: "" },
        { name: "", cyqk: "", fwbx: "" },
        { name: "", cyqk: "", fwbx: "" },
        { name: "", cyqk: "", fwbx: "" },
      ],
    };
  },
  mounted(){
    this.getServiceItemsPerson()
  },
  methods: { 
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;
      this.getServiceItemsPerson();
    },
    // 获取参加人员列表
    getServiceItemsPerson() {
      this.tableData = []
      console.log('rowid',this.rowid);
      post("/admin/serviceItemsPerson/info/listServiceItemsPerson", {
        serviceItemsId: this.rowid,
        pageNo: this.pageConfig.pageNo,
        pageSize: this.pageConfig.pageSize,
      }).then((res) => {
        if(res.code == 200){  
          this.tableData = res.content.list; 
          this.pageConfig.total = res.content.count;
        }  
      });
    },
    getData(){
      console.log('getData');
      this.tableData = []; 
    }, 
    handleCurrentChanges() {
      console.log(111);
    },
    dy() {
      this.$print(this.$refs.print);
    },
    clearForm(){
      this.$emit("close")
    },
  },
  mounted() {
    this.getServiceItemsPerson()
    // console.log('info',this.rowid,"++",this.readonlyApproval);
  },
};

</script>

<style lang="less">
.dayincss {
  h2 {
    text-align: center;
    font-weight: 800;
    margin-bottom: 20px;
  }
  .twohang {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    span:first-child {
      box-sizing: border-box;
      padding-left: 100px;
      width: 650px;
    }
  }
}
</style> 
